import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import { Container } from 'react-bootstrap';
import QueryForm from './QueryForm';
import TravellerRateCard from './TravellerRateCard';
import TravelSection from './TravelSection';
import OutstationTour from './OutstationTour';
import WhyChooseUs from './WhyChooseUs';
import Faqs from './Faqs';
import Testimonials from './Testimonials';



const slides = [
  {
    id: 1,
    image: '/Images/tempo1.jpg',
    heading: 'Comfortable Tempo Travellers',
    subText: 'Perfect for group road trips',
    buttonText: 'Book Now'
  },
  {
    id: 2,
    image: '/Images/tempo2.webp',
    heading: 'Luxurious Minibuses',
    subText: 'Travel in style and space',
    buttonText: 'View Packages'
  },
  {
    id: 3,
    image: '/Images/tempo-traveller-banner.jpg',
    heading: 'Outstation Car Rentals',
    subText: 'Drive beyond the city limits',
    buttonText: 'Explore Now'
  }
];

const Home = () => {
  const [current, setCurrent] = useState(1); // start at first real slide
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const slideInterval = useRef(null);

  const extendedSlides = [
    slides[slides.length - 1],
    ...slides,
    slides[0]
  ];

  const startAutoSlide = () => {
    slideInterval.current = setInterval(() => {
      nextSlide();
    }, 3000);
  };

  const resetInterval = () => {
    clearInterval(slideInterval.current);
    startAutoSlide();
  };

  const nextSlide = () => {
    setCurrent((prev) => prev + 1);
    setTransitionEnabled(true);
  };

  const prevSlide = () => {
    setCurrent((prev) => prev - 1);
    setTransitionEnabled(true);
  };

  // Fix looping
  useEffect(() => {
    if (current === extendedSlides.length - 1) {
      setTimeout(() => {
        setTransitionEnabled(false);
        setCurrent(1); // jump to first real
      }, 600);
    } else if (current === 0) {
      setTimeout(() => {
        setTransitionEnabled(false);
        setCurrent(extendedSlides.length - 2); // jump to last real
      }, 600);
    }
  }, [current, extendedSlides.length]);

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(slideInterval.current);
  }, []);

  return (
    <div>
      <div
        className="slider-container"
        onMouseEnter={() => clearInterval(slideInterval.current)}
        onMouseLeave={startAutoSlide}
      >
        <div
          className="slider-track"
          style={{
            transform: `translateX(-${(current + 1) * 100}%)`,
            transition: transitionEnabled ? 'transform 0.6s ease-in-out' : 'none'
          }}
        >
          {extendedSlides.map((slide, index) => (
            <div key={index} className="slider-slide">
              <img src={slide.image} alt={`Slide ${slide.id}`} className="slider-image" />
              <div className="slider-content">
                <h2>{slide.heading}</h2>
                <p>{slide.subText}</p>
                <button className="slider-button">{slide.buttonText}</button>
              </div>
            </div>
          ))}
        </div>

        <button className="slider-arrow slider-prev" onClick={() => { prevSlide(); resetInterval(); }}>❮</button>
        <button className="slider-arrow slider-next" onClick={() => { nextSlide(); resetInterval(); }}>❯</button>
      </div>
      <Container>
<div id="query-form">
  <QueryForm />
</div>
      <TravelSection/>
      <TravellerRateCard/>
      <OutstationTour/>
      <WhyChooseUs/>
      <Faqs/>
      <Testimonials/>

    </Container>
    </div>
  );
};

export default Home;
